// Announcement Marquee Script
class AnnouncementMarquee {
  constructor(element) {
    this.element = element;
    this.inner = element.querySelector('.announcement-bar__marquee-inner');
    this.speedMobile = parseInt(element.dataset.marqueeSpeedMobile) || 30;
    this.speedDesktop = parseInt(element.dataset.marqueeSpeedDesktop) || 120;
    this.baseItemCount = null;

    this.init();
    this.setupResizeListener();
  }

  init() {
    if (this.inner) {
      // Count unique announcement items (divide by 10 since we repeat 10 times)
      const totalItems = this.inner.querySelectorAll('.announcement-bar__message').length;
      this.baseItemCount = totalItems / 10;
      this.updateSpeed();
    }
  }

  updateSpeed() {
    const isMobile = window.innerWidth < 750;
    const baseSpeed = isMobile ? this.speedMobile : this.speedDesktop;

    // Adjust speed based on number of unique announcements
    // More announcements = proportionally longer duration to maintain same visual speed
    const adjustedSpeed = baseSpeed * this.baseItemCount;

    this.inner.style.animationDuration = `${adjustedSpeed}s`;
  }

  setupResizeListener() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.updateSpeed();
      }, 250);
    });
  }
}

// Initialize all marquee announcement bars
document.addEventListener('DOMContentLoaded', () => {
  const marqueeElements = document.querySelectorAll('.announcement-bar--marquee');
  marqueeElements.forEach(element => {
    new AnnouncementMarquee(element);
  });
});

// Re-initialize when Shopify theme editor makes changes
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const marqueeElements = event.target.querySelectorAll('.announcement-bar--marquee');
    marqueeElements.forEach(element => {
      new AnnouncementMarquee(element);
    });
  });
}
